require('vendor/css/docs.min.css');
require('vendor/css/pickadate/classic.css');
require('vendor/css/pickadate/classic.date.css');
require('vendor/css/pickadate/classic.time.css');
require('vendor/sass/bootstrap/bootstrap.scss');
require('vendor/css/quill/quill.snow.css');
require('vendor/css/dragula.css');
require('vendor/css/jquery.atwho.css');
require('vendor/css/croppie.css');

require('vendor/css/froala_editor.pkgd.css');
require('vendor/css/froala_style.css');

require('vendor/css/stripe.css');
require('expose-loader?exposes=initializeStripe!vendor/stripe.js');

require('vendor/jquery.form');
require('vendor/backbone.js');
require('vendor/chart.js');
require('expose-loader?exposes=Nanobar!vendor/nanobar.js');
require('expose-loader?exposes=jstz!vendor/jstz.js');
require('expose-loader?exposes=dragula!vendor/dragula.js');
require('expose-loader?exposes=Quill!quill');
